module.exports = __webpack_public_path__ + "static/img/c4-1.78d927eb.jpg";